"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEXUS_THEME_METADATA = exports.NEXUS_PROPERTY_METADATA = exports.NEXUS_COMPONENT_METADATA = exports.NEXUS_PANEL_METADATA = exports.NEXUS_PLUGIN_METADATA = void 0;
require("reflect-metadata");
// 装饰器元数据
exports.NEXUS_PLUGIN_METADATA = Symbol('nexus:plugin');
exports.NEXUS_PANEL_METADATA = Symbol('nexus:panel');
exports.NEXUS_COMPONENT_METADATA = Symbol('nexus:component');
exports.NEXUS_PROPERTY_METADATA = Symbol('nexus:property');
exports.NEXUS_THEME_METADATA = Symbol('nexus:theme');
